export function createRealtimeQueryReconciler(
  isFetching: () => boolean,
  refetch: () => Promise<unknown>
): () => Promise<void> {
  let activeRequest: Promise<void> | null = null
  let refreshQueued = false

  return function reconcile(): Promise<void> {
    if (activeRequest) {
      refreshQueued = true
      return activeRequest
    }

    const joinedExistingRequest = isFetching()
    activeRequest = (async () => {
      let needsPostRequestSnapshot = joinedExistingRequest
      do {
        refreshQueued = false
        await refetch()
        if (needsPostRequestSnapshot) {
          needsPostRequestSnapshot = false
          refreshQueued = true
        }
      } while (refreshQueued)
    })().finally(() => {
      activeRequest = null
    })

    return activeRequest
  }
}
